import React from "react";
import { twMerge } from "tailwind-merge";

export type StepStatus = "done" | "current" | "next";

export interface Step {
  title: React.ReactNode;
  description?: React.ReactNode;
  status: StepStatus;
  marker?: React.ReactNode;
}

export interface StepListProps {
  steps: Step[];
  className?: string;
}

const MARKER_TONES: Record<StepStatus, string> = {
  done: "bg-green-100 text-green-700",
  current: "bg-blue-600 text-white",
  next: "bg-gray-100 text-gray-500",
};

const TITLE_TONES: Record<StepStatus, string> = {
  done: "text-gray-500",
  current: "font-medium text-gray-900",
  next: "text-gray-500",
};

export const StepList: React.FC<StepListProps> = ({ steps, className }) => (
  <ol className={twMerge("flex flex-col gap-3 text-sm", className)}>
    {steps.map((step, index) => (
      <li key={index} className="flex gap-2.5" dir="auto">
        <span
          aria-hidden="true"
          className={twMerge(
            "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
            MARKER_TONES[step.status]
          )}
        >
          {step.marker ?? (step.status === "done" ? "✓" : index + 1)}
        </span>
        <div className="min-w-0">
          <p className={TITLE_TONES[step.status]}>{step.title}</p>
          {step.description ? (
            <p className="text-xs text-gray-500">{step.description}</p>
          ) : null}
        </div>
      </li>
    ))}
  </ol>
);

export default StepList;
